import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { useRouter } from '../services/Navigation';

export const Route = createFileRoute('/')({
  component: LandingRoute,
});

function LandingRoute() {
  const router = useRouter();

  useEffect(() => {
    router.push('/m/mate');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
